<template>
  <div class="statistics">
    <h3 class="time" v-if='time'>{{ ended ? "FT" : time + "'" }}</h3>
    <span v-if='firstTime' class='ht-time'>
      НТ: {{ firstTime.home }} - {{ firstTime.away }}
    </span>
    <div class="info">
      <div class="block" style="background-color: #c5c5c5" :class="[homeLevelClass]" v-if='homeLevelClass'></div>

      <div class="all-info">
        <div class="statistic-item" v-if='totalHdp'>
          <span>{{ overHdp }}</span> <span>Handicap: {{ totalHdp }}</span><span>{{ underHdp }}</span>
        </div>
        <div class="statistic-item" v-if='total'>
          <span>{{ over }}</span> <span>Total: {{ total }}</span><span>{{ under }}</span>
        </div>
        <div class="statistic-item" v-if='odds'>
          <span class='danger'>{{ odds.FThdp.over }}</span> <span>Handicap: <span class='danger'>{{ odds.FThdp.total
              }}</span></span>
          <span class='danger'>{{ odds.FThdp.under }}</span>
        </div>
        <div class="statistic-item" v-if='odds'>
          <span class='danger'>{{ odds.FT.over }}</span> <span>Total: <span class='danger'>{{ odds.FT.total
              }}</span></span><span class='danger'>{{ odds.FT.under }}</span>
        </div>
        <div class="statistic-item" v-for="{ key, title } in statList" :key="title">
          <span v-if='["goal", "loss", "corner"].includes(key)' style="white-space: nowrap;">
            <span :class="colorStatItem(title, getStatisticValue(home, key, true))">
              {{ getStatisticValue(home, key, true) }}
            </span>
            /
            <span :class="colorStatItem(title, getStatisticValue(home, key))">
              {{ getStatisticValue(home, key) }}
            </span>
          </span>
          <span v-else-if='["dAtk", "shots", "sOn", "sOff"].includes(key)' :class="getcolorStatItem(home[key].level)">
            {{ home[key].value || "0" }} </span>
          <span v-else :class="colorStatItem(title, prepareStat(key, home))" style="white-space: nowrap;">
            {{ prepareStat(key, home) }}
          </span>
          <span>{{ title }}</span>
          <span v-if='["goal", "loss", "corner"].includes(key)' style="white-space: nowrap;">
            <span :class="colorStatItem(title, getStatisticValue(away, key, true))">
              {{ getStatisticValue(away, key, true) }}
            </span>
            /
            <span :class="colorStatItem(title, getStatisticValue(away, key))">
              {{ getStatisticValue(away, key) }}
            </span>
          </span>
          <span v-else-if='["dAtk", "shots", "sOn", "sOff"].includes(key)' :class="getcolorStatItem(away[key].level)">
            {{ away[key].value || "0" }} </span>
          <span v-else :class="colorStatItem(title, prepareStat(key, away))" style="white-space: nowrap;">
            {{ prepareStat(key, away) }}
          </span>
        </div>
      </div>
      <div class="block" style="background-color: #c5c5c5" :class="[awayLevelClass]" v-if='awayLevelClass'></div>
    </div>
  </div>
</template>


<script>
export default {
  name: "LiveStatistics",
  props: {
    id: Number,
    away: Object,
    home: Object,
    over: String,
    overHdp: String,
    time: Number,
    total: String,
    totalHdp: String,
    under: String,
    underHdp: String,
    statList: Array,
    odds: Object,
    // CSS Classes
    homeLevelClass: String,
    awayLevelClass: String,
    firstTime: {
      type: [Object, Boolean],
      default: false,
    },
    ended: Boolean,
    isPre: Boolean,
  },
  methods: {
    getStatisticValue(team, key, isFirst = false) {
      if (this.isPre) {
        return isFirst
          ? (team[key] && team[key]['3']) || 0
          : (team[key] && team[key]['10']) || 0;
      }

      return isFirst
        ? (team[key] && team[key]['3'] && team[key]['3'].value) || 0
        : (team[key] && team[key]['10'] && team[key]['10'].value) || 0;
    },
    getcolorStatItem(level = 0) {
      switch (level) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        default:
          return '';
      }
    },
    colorStatItem(title, value = 0) {
      switch (title) {
        case "Scored":
        case "Conceded":
          if (value === "0") return '';
          if (value >= 1.6) return 'danger';
          if (value >= 1.3) return 'warning';
          return '';

        case "xG":
          if (value >= 2.5) return 'danger';
          if (value >= 1.5) return 'warning';
          if (value >= 0.5) return 'success';
          return '';

        case "PPM":
          if (value > 2) return 'danger';
          if (value > 1.5) return 'warning';
          if (value > 1) return 'success';
          return '';

        default:
          return '';
      }
    },

    prepareStat(stat, team) {
      if (!team || !team[stat]) return "0";
      if (this.isPre) {
        if (stat === 'ppm') {
          return team[stat] || "-";
        }
        return team[stat] || "0";
      }
      if (stat === 'ppm') {
        return team[stat].value || "-";
      }
      return team[stat].value || "0";
    },
  }
}
</script>

<style lang="scss" scoped>
.statistics {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  width: max-content;

  .time {
    font-weight: 700;
    font-size: 36px;
    line-height: 45.07px;
    color: var(--font-color);
  }

  .ht-time {
    margin-bottom: 15px;
  }

  .info {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 26px;

    .block {
      height: 330px;
      width: 10px;
      border-radius: 10px;
      margin: 0;
    }

    .all-info {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      .statistic-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: 400px;
        min-width: 226px;
        padding: 2px 6px 2px 6px;
        border-radius: 8px;
        background-color: var(--shots-body-color);

        span {
          font-weight: 500;
          font-size: 12px;
          line-height: 14.88px;
        }
      }

      .statistic-item span:first-child,
      .statistic-item span:last-child {
        width: 50px;
        text-align: center;
      }
    }
  }
}

.team-level-success {
  background-color: var(--success-color) !important;
}

.team-level-danger {
  background-color: var(--danger-color) !important;
}

.team-level-warning {
  background-color: var(--warning-color) !important;
}

.success {
  color: var(--success-color) !important;
}

.danger {
  color: var(--danger-color) !important;
}

.warning {
  color: var(--warning-color) !important;
}

@media screen and (max-width: 768px) {

  .statistics {
    order: 3;
    grid-column: span 2 / span 2;
    margin: 0 auto;
    margin-top: 50px;
    height: auto;
    width: 80%;
  }
}

@media screen and (max-width: 468px) {
  .statistics {
    margin-top: 30px;

    .ht-time {
      margin-bottom: 5px;
    }

    .info {
      gap: 10px;
      width: auto;
    }
  }
}
</style>